import type { DirectoryGroupModel } from "models/DirectoryGroupModel";

import { multiGetDirectoryGroups } from "api/directoryGroups";
import constate from "constate";
import { useThrottledBulkFetch } from "hooks/useThrottledBulkFetch";
import { useCallback } from "react";

const useDirectoryGroups = () => {
  const { itemsById, loadIds, setItemsById } = useThrottledBulkFetch(multiGetDirectoryGroups, {
    includeDeleted: true,
    throttleTime: 50,
  });

  const addGroups = useCallback(
    (groups: DirectoryGroupModel[]) => {
      const missingGroups = groups.filter((group) => !itemsById.has(group.id));
      if (!missingGroups.length) return;
      setItemsById((curr) => {
        missingGroups.forEach((group) => {
          curr = curr.set(group.id, group);
        });
        return curr;
      });
    },
    [itemsById, setItemsById],
  );

  return { actions: { addGroups, loadGroups: loadIds }, state: { directoryGroupsById: itemsById } };
};

export const [DirectoryGroupsProvider, useDirectoryGroupsContext] = constate(useDirectoryGroups);
